import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import axios from 'axios'

import ServerError from './common/500'
Vue.component('ServerError', ServerError)
import VueElementLoading from 'vue-element-loading'
Vue.component('VueElementLoading', VueElementLoading)
import { VueEditor } from "vue2-editor";
Vue.component('VueEditor', VueEditor)

Vue.config.productionTip = false

// axios.defaults.baseURL = 'http://localhost:4003';
// Vue.prototype.baseURL = 'http://localhost:4003';
// Vue.prototype.mediaURLOld = 'http://localhost:4003';
// Vue.prototype.mediaURL = 'http://localhost:4003/file/get/';

// axios.defaults.baseURL = 'http://13.233.1.101';
// Vue.prototype.baseURL = 'http://13.233.1.101';
// Vue.prototype.mediaURLOld = 'http://13.233.1.101';
// Vue.prototype.mediaURL = 'http://13.233.1.101/file/get/';

// axios.defaults.baseURL = 'http://whalewatch.leopardtechlabs.in';
// Vue.prototype.baseURL = 'http://whalewatch.leopardtechlabs.in';
// Vue.prototype.mediaURLOld = 'http://whalewatch.leopardtechlabs.in';
// Vue.prototype.mediaURL = 'http://whalewatch.leopardtechlabs.in/file/get/';

axios.defaults.baseURL = 'https://api.vhaliwatchergujarat.com';
Vue.prototype.baseURL = 'https://api.vhaliwatchergujarat.com';
Vue.prototype.mediaURLOld = 'https://api.vhaliwatchergujarat.com';
Vue.prototype.mediaURL = 'https://api.vhaliwatchergujarat.com/file/get/';

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
